import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-2xl font-bold mt-6 font-heading text-foreground-950">这个页面走丢了</h1>
        <p className="mt-2 text-sm text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-base text-foreground-600">可能链接有误，回首页看看最新的瓜吧。</p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line text-base"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}